import { render, staticRenderFns } from "./DisputeResolutionFormDetailsEscalated.vue?vue&type=template&id=08fb60a6&scoped=true&"
import script from "./DisputeResolutionFormDetailsEscalated.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionFormDetailsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResolutionFormDetailsEscalated.vue?vue&type=style&index=0&id=08fb60a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb60a6",
  null
  
)

export default component.exports